import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { Select, Store } from '@ngxs/store';
import { CountryDataState } from 'app/store/country/country-data.state';
import { Observable, Subject, takeUntil } from 'rxjs';
import { CountryData } from 'app/models/dto/country-data.model';
import { SelectCountry } from 'app/store/country/country-data.actions';

@Component({
  selector: 'phone-number-input',
  template: `
  <div *ngIf="!field.hide" class="formly-sub-row">
    <mat-form-field class="formly-sub-column-2">
      <mat-label>{{ label ? label : 'Phone' }}</mat-label>
      <input
        type="input"
        matInput
        [mask]="mask"
        [formControl]="field.formControl"
        [formlyAttributes]="field"
        data-cy="phone-number-input"
        [placeholder]="to.placeholder ? to.placeholder : ''">
    </mat-form-field>
    </div>
  `,
  styleUrls: ['./formly-grid-styles.scss']
})
export class PhoneNumberInputComponent extends FieldType<FieldTypeConfig> implements OnInit, OnDestroy {
  @Select(CountryDataState.selectedCountry) selectedCountry$: Observable<CountryData>;
  selectedCountryCode: string | undefined;
  mask: string = '(000) 000-0000';
  destroyed$ = new Subject<boolean>();
  label: string | null;

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store
  ) {
    super();
  }
  ngOnInit() {
    this.label = this.field.props.label ? this.field.props.label : (this.field.parent?.props?.label ? this.field.parent.props.label : null);
    // This will reset the selected Country
    this.store.dispatch(new SelectCountry(0));
    this.selectedCountry$
      .pipe(takeUntil(this.destroyed$))
      .subscribe( countryData => {
        this.selectedCountryCode = countryData?.countryCode;
        this.setPhoneMask();
      });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  setPhoneMask() {
    this.mask = this.selectedCountryCode === 'GB' ? '0000 000000' : '(000) 000-0000';
    this.cdRef.detectChanges();
  }
}
